import { List, ListItem } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { SelectFieldType } from '@/type';

interface SelectInputTooltipContentProps {
  selected: string[] | number[];
  selectField: SelectFieldType;
}

const SelectInputGetTooltipContent = ({
  selected,
  selectField,
}: SelectInputTooltipContentProps) => {
  if (!selected) return null;

  if (Array.isArray(selected)) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          wordBreak: 'break-word',
          listStyleType: 'disc',
        }}
      >
        <List
          sx={{
            padding: 1,
            borderRadius: 'var(--button-border-radius)',
            backgroundColor: 'rgba(74, 74, 74, 0.8)',
            color: 'var(--text-color-light)',
            fontSize: '75%',
          }}
        >
          {selected?.map((item, index) => {
            const label =
              selectField.options.find((option) => option.value === item)?.label || item;
            return (
              <ListItem
                sx={{
                  display: 'flex',
                  padding: 0,
                  gap: 2,
                }}
                key={index}
              >
                <Box component='span'>•</Box>
                {label}
              </ListItem>
            );
          })}
        </List>
      </Box>
    );
  }

  return (
    selectField.options?.find((option) => option.value === selected)?.label ||
    String(selected)
  );
};

export default SelectInputGetTooltipContent;
